import React, { useContext } from 'react'
import NPOSAccountInnerStyle from './css/NPOSAccountInnerStyle'
import { nposAccountControllerContext } from './NPOSAccountController'
import UsersAccountsController from './components/users_accounts/UsersAccountsController'
import AdminConfigController from './components/admin_config/AdminConfigController'
import UsersSchedulerController from './components/users_scheduler/UsersSchedulerController'

function NPOSAccountInner() {
  const nposAccountController = useContext(nposAccountControllerContext)
  const activeTab = nposAccountController.activeTab[0]

  return (
    <React.Fragment>
      { (activeTab) ? (activeTab === 'users-accounts') ? <UsersAccountsController /> : null : null }
      { (activeTab) ? (activeTab === 'admin-config') ? <AdminConfigController /> : null : null }
      { (activeTab) ? (activeTab === 'users-scheduler') ? <UsersSchedulerController /> : null : null }
      <NPOSAccountInnerStyle />
    </React.Fragment>
  )
}

export default React.memo(NPOSAccountInner)